import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';



@Component({
  selector: 'subscriber-search',
  templateUrl: 'subscriberManagement.search.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})

export class SubscriberManagementSearchComponent implements OnInit {
  @Input() public queryString: string;
  @Input() public textboxPlaceholder = 'Search by: First Name, Last Name, Last 4 SSN, Full SSN';
  @Input() public showClearButton = false;
  @Output() searchSubmitted: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {
  }

  clear(): void {
    this.queryString = '';
    this.searchSubscribers();
  }

  searchSubscribers() {
      this.searchSubmitted.emit(this.queryString);
  }

  inputClass(): string {
    if (this.showClearButton)
      return "form-control show-clear";

    return "form-control";
  }
}
